<template>
  <div class="url-tool">
    <div class="input-container">
      <div class="input-group left">
        <label for="dataInput">Input:</label>
        <textarea
          id="dataInput"
          v-model="dataInput"
          placeholder="Enter text here..."
          rows="10"
        ></textarea>
      </div>
      <div class="input-group right">
        <label for="dataOutput">Output:</label>
        <textarea
          id="dataOutput"
          v-model="dataOutput"
          placeholder=""
          rows="10"
          readonly
        ></textarea>
      </div>
    </div>
    <div class="button-container">
      <button @click="clearAll">Clear All</button>
      <button @click="encodeUrl">Encode URL</button>
      <button @click="decodeUrl">Decode URL</button>
      <button @click="copyOutput">Copy Output</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataInput: '',
      dataOutput: ''
    };
  },
  methods: {
    encodeUrl() {
      try {
        this.dataOutput = encodeURIComponent(this.dataInput);
      } catch (error) {
        console.error('Error encoding URL:', error);
        alert('Failed to encode URL.');
      }
    },
    decodeUrl() {
      try {
        this.dataOutput = decodeURIComponent(this.dataInput);
      } catch (error) {
        console.error('Error decoding URL:', error);
        alert('Failed to decode URL.');
      }
    },
    clearAll() {
      this.dataInput = '';
      this.dataOutput = '';
    },
    copyOutput() {
      if (this.dataOutput) {
        navigator.clipboard.writeText(this.dataOutput)
          .then(() => {
            alert('Output copied to clipboard!');
          })
          .catch(err => {
            console.error('Failed to copy output: ', err);
            alert('Failed to copy output.');
          });
      }
    }
  }
};
</script>

<style scoped>
.url-tool {
  width: 100%;
  height: 70vh; /* 确保组件充满整个视口高度 */
  margin: 0;
  padding: 15px 0px;
  display: flex;
  flex-direction: column;
}

.input-container {
  flex: 1; /* 使输入容器充满剩余空间 */
  display: flex;
  justify-content: space-between;
}

.input-group {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.input-group.left {
  margin-right: 5px; /* 添加右侧间距 */
}

.input-group.right {
  margin-left: 5px; /* 添加左侧间距 */
}

.input-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: light;
}

textarea {
  flex: 1; /* 使 textarea 充满剩余空间 */
  padding: 10px;
  margin-top: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical;
  width: 100%;
  box-sizing: border-box; /* 确保内边距和边框包含在宽度内 */
}

textarea[readonly] {
  background-color: #f9f9f9;
  color: #333;
}

.button-container {
  text-align: center;
  margin-top: 20px;
}

button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  transition: background-color 0.3s;
  margin: 0 5px;
}

button:hover {
  background-color: #0056b3;
}

button.clear-all {
  background-color: #dc3545;
}

button.copy-output {
  background-color: #28a745;
}
</style>
